<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Property, USP, 2x Photo:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'PropertyUsp2x1Image')"
            [blockData]="block.variables?.PropertyUsp2x1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="PropertyUsp2x1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp2x2Image')"
            [blockData]="block.variables?.PropertyUsp2x2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="PropertyUsp2x2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp2x1ImageHref')"
            [blockData]="block.variables?.PropertyUsp2x1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="PropertyUsp2x1ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyUsp2x1ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.PropertyUsp2x1ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'PropertyUsp2x2ImageHref')"
            [blockData]="block.variables?.PropertyUsp2x2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="PropertyUsp2x2ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyUsp2x2ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.PropertyUsp2x2ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'alt'"
            (handleOnChange)="onChange($event, 'PropertyUsp2x1ImageAlt')"
            [blockData]="block.variables?.PropertyUsp2x1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="PropertyUsp2x1ImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp2x2ImageAlt')"
            [blockData]="block.variables?.PropertyUsp2x2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="PropertyUsp2x2ImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp2xName')"
            [blockData]="block.variables?.PropertyUsp2xName ?? ''"
            [placeholder]="namePlaceholder"
            variable="PropertyUsp2xName"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyUsp2x1Usp')"
            [blockData]="block.variables?.PropertyUsp2x1Usp ?? ''"
            [placeholder]="usp1Placeholder"
            variable="PropertyUsp2x1Usp"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyUsp2x2Usp')"
            [blockData]="block.variables?.PropertyUsp2x2Usp ?? ''"
            [placeholder]="usp2Placeholder"
            variable="PropertyUsp2x2Usp"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyUsp2x3Usp')"
            [blockData]="block.variables?.PropertyUsp2x3Usp ?? ''"
            [placeholder]="usp3Placeholder"
            variable="PropertyUsp2x3Usp"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-6" *ngIf="block.variables?.PropertyUsp2x1Image">
            <a
              target="_blank"
              [href]="
                helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyUsp2x1ImageHref))
              "
              ><img
                [src]="$safeNavigationMigration(block.variables?.PropertyUsp2x1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.PropertyUsp2x1ImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.PropertyUsp2x2Image">
            <a
              target="_blank"
              [href]="
                helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyUsp2x2ImageHref))
              "
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.PropertyUsp2x2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.PropertyUsp2x2ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left">
          <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp2xName)"></p>
        </div>
        <div *ngIf="block.variables?.PropertyUsp2x1Usp">
          <ul class="list-group">
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="block.variables?.PropertyUsp2x1Usp"
            >
              <div class="usp-container">
                <img
                  src="https://email.valamar.com/assets/responsysimages/content/valamarri/afasfafsaf244.png"
                  height="24"
                  width="24"
                  alt=""
                />
                <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp2x1Usp)"></p>
              </div>
            </li>
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="block.variables?.PropertyUsp2x2Usp"
            >
              <div class="usp-container">
                <img
                  src="https://email.valamar.com/assets/responsysimages/content/valamarri/afasfafsaf244.png"
                  height="24"
                  width="24"
                  alt=""
                />
                <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp2x2Usp)"></p>
              </div>
            </li>
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="block.variables?.PropertyUsp2x3Usp"
            >
              <div class="usp-container">
                <img
                  src="https://email.valamar.com/assets/responsysimages/content/valamarri/afasfafsaf244.png"
                  height="24"
                  width="24"
                  alt=""
                />
                <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp2x3Usp)"></p>
              </div>
            </li>
          </ul>
          <div class="col-12" *ngIf="block.variables?.PropertyUsp2xCtaLink">
            <a
              target="_blank"
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.PropertyUsp2xCtaLink)"
              role="button"
              [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp2xCtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
